import { createContext, useContext } from 'react';
import { ChartMetadataT } from 'routes/Explore/hooks/chartMetadata';

const ChartMetadataContext = createContext<ChartMetadataT | undefined>(
    undefined,
);

export const ChartMetadataProvider = ChartMetadataContext.Provider;
export const useChartMetadataContext = () => useContext(ChartMetadataContext);
